<template lang="pug">
  .dashboard-products
    v-card(flat :outlined="$vuetify.breakpoint.smAndDown ? false : true" :class="$vuetify.breakpoint.smAndDown ? '' : 'mx-2 pt-2'")
      .main-container
        v-tabs(v-model="selectedType" color="textColorAccent" :height="40" grow)
          v-tab.button-AA-medium {{ $t('by_sales_amount') }}
          v-tab.button-AA-medium {{ $t('by_conversion_rate') }}
        div.separator(:style="{ 'background-color':$vuetify.theme.themes[$theme].basic600T16 }")

      v-simple-table(fixed-header)
        thead
          tr
            th.s2.primary400--text.text-center.pr-2(style="width:50px;") {{ $t('rank') }}
            th.s2.primary400--text.px-2 Product
            template(v-if="rankingType == 'sales'")
              th.s2.primary400--text.text-center.px-2(style="width:50px;") {{ $t('units') }}
              th.s2.primary400--text.text-right.pl-2(style="min-width:90px;") {{ $t('sales') }} ({{ $currency.symbol }})
            th.s2.primary400--text.text-right.pl-2(v-else style="min-width:125px;") {{ $t('conversion_rate') }}
        tbody
          template(v-if="products.length > 0")
            tr(v-for="(product, index) in  products" :key="product.id" :class="index % 2 === 0? 'basic200' : ''")
              td.text-center.my-auto.pr-2(style="width:50px")
                .p2.textColor--text {{ product.rank }}
              td.my-auto.px-2(style="max-height:26px; overflow: hidden;")
                .s2.textColor--text {{ product.variant_for_product_name ? `${product.variant_for_product_name} (${product.name})` : product.name }}
              template(v-if="rankingType === 'sales'")
                td.text-center.my-auto.px-2(style="width:50px")
                  .p2.textColor--text {{ product.units_sold }}
                td.text-right.my-auto.pl-2(style="min-width:90px")
                  .p2.textColor--text {{ product.sales_amount | displayPriceRaw }}
              td.text-right.my-auto.pl-2(v-else style="width:50px")
                .p2.textColor--text {{ product.conversion_rate | percentage }}
          tr(v-else style="overflow: visible;")
            td(:colspan="rankingType === 'sales' ? '4' : '3'")
              div.s2.ma-4.text-center {{ $t('no_matching_records') }}
      v-divider

    .modals
      add-product(v-if="showAddProductDialog" :open.sync="showAddProductDialog" :product.sync="editProduct")
</template>

<script>
import AddProduct from '@/components/dialogs/AddProduct.vue'

export default {
  props: ['company', 'span', 'dateRange'],
  components: { AddProduct },
  data () {
    return {
      selectedType: 0,
      rankingType: 'sales',
      totalProducts: 0,
      responseProducts: [],
      products: [],
      loading: true,
      editProduct: null,
      showAddProductDialog: false
    }
  },
  watch: {
    selectedType (val) {
      if (val == 0) {
        this.rankingType = 'sales'
      } else {
        this.rankingType = 'conversion'
      }
    },
    rankingType () {
      this.fetchProducts()
    },
    span: {
      handler (val) {
        if (val !== 'custom') {
          this.fetchProducts()
        }
      },
      deep: true
    },
    dateRange (val) {
      if (val.length === 2) {
        this.fetchProducts()
      }
    }
  },
  mounted () {
    this.fetchProducts()
  },
  methods: {
    fetchProducts() {
      this.loading = true
      let url = `/products/${this.rankingType}_ranking/?page=1&page_size=20&company=${this.company.id}&ordering=-id&span=${this.span}`
      if (this.span === 'custom') {
        url = `/products/${this.rankingType}_ranking/?page=1&page_size=20&company=${this.company.id}&ordering=-id&from=${this.dateRange[0]}&until=${this.dateRange[1]}`
      }
      this.$axios.get(url).then((response) => {
        this.isFetching = false
        this.products = response.data.results.map((p, index) => { return { ...p, rank: index + 1 } })
        this.responseProducts = this.products
        this.totalProducts = response.data.count
        this.loading = false
      }).catch(() => {})
    },
    openProductDialog (item) {
      let productId = item.variant_for_product_id || item.id
      this.$axios.get(`/products/${productId}/`)
      .then(resp => {
        this.editProduct = resp.data
        this.showAddProductDialog = true
      }).catch(() => {})
    }
  }
}
</script>

<style lang="scss" scoped>
.main-container {
  position: relative;
}
.separator {
  position: absolute;
  height:2px;
  top: 38px;
  left: 0px;
  right: 0px;
}
</style>

<i18n>
{
  "en": {
    "sales_team": "Sales team",
    "forms": "Forms",
    "by_sales_amount": "By sales amount",
    "by_conversion_rate": "By conversion rate",
    "rank": "Rank",
    "units": "Units",
    "conversion_rate": "Conversion rate",
    "no_matching_records": "No matching records found"
  },
  "id": {
    "sales_team": "Tim Penjualan",
    "forms": "form",
    "by_sales_amount": "Berdasarkan jumlah penjualan",
    "by_conversion_rate": "Berdasarkan tingkat konversi",
    "rank": "Peringkat",
    "units": "Unit",
    "conversion_rate": "Tingkat konversi",
    "no_matching_records": "Tidak ada catatan ditemukan"
  }
}
</i18n>